import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class CacheControlConfig {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getIsEnabled(): boolean {
		return this.configService.get((x) => x.universalExpress.cacheControl.isEnabled, false);
	}

	getMaxAge(routeName: string): number {
		const maxAgeByRoutes = this.getMaxAgeByRoutes();
		return (maxAgeByRoutes && maxAgeByRoutes[routeName]) || this.getDefaultMaxAge();
	}

	getBotHeader() {
		return this.configService.get((x) => x.universalExpress.cacheControl.botHeader, "X-OBG-BOT");
	}

	getBotMaxAge() {
		return this.configService.get((x) => x.universalExpress.cacheControl.defaultBotMaxAge, 86400);
	}

	getVaryHeader(routeName: string): string {
		const varyHeaderByRoutes = this.getVaryHeadersByRoutes();
		return (varyHeaderByRoutes && varyHeaderByRoutes[routeName]) || this.getDefaultVaryHeader();
	}

	getCdsByRoute(name: string): boolean {
		const routes = this.configService.get((x) => x.universalExpress.cacheControl.cdsRoutes, {});
		return !!routes[name];
	}

	private getMaxAgeByRoutes(): Record<string, number> | undefined {
		return this.configService.get((x) => x.universalExpress.cacheControl.maxAgeByRoutes, undefined) as
			| Record<string, number>
			| undefined;
	}

	private getDefaultMaxAge(): number {
		return this.configService.get((x) => x.universalExpress.cacheControl.defaultMaxAge, 1800);
	}

	private getDefaultVaryHeader(): string {
		return this.configService.get(
			(x) => x.universalExpress.cacheControl.defaultVaryHeader,
			"Accept-Language, Accept-Encoding, X-OBG-Device, X-OBG-Country-Code, X-OBG-Channel, Cookie"
		);
	}

	private getVaryHeadersByRoutes(): Record<string, string> | undefined {
		return this.configService.get((x) => x.universalExpress.cacheControl.varyHeaderByRoutes, undefined) as
			| Record<string, string>
			| undefined;
	}
}
